import { Injectable } from '@angular/core';
import moment from 'moment';
import { Period } from '../moleds/period.enum';

@Injectable({
  providedIn: 'root'
})
export class LeadershipService {
  getFormattedTime(date: Date, period: string): any {
    switch (Period[period]) {
      case Period.weekly:
        return this.getWeek(date);
      case Period.monthly:
        return date.toDateString().split(' ')[1];
      case Period.quarterly:
        return this.getQuarterly(date);
      case Period.yearly:
        return date.getFullYear();

    }
  }

  getIntervalFormattedLabel(interval: string): string {
    return {
      [Period.weekly]: `${moment().startOf('week').format('MMMM DD')} – ${moment().endOf('week').format('MMMM DD')}`,
      [Period.monthly]: moment().format('MMMM YYYY'),
      [Period.quarterly]: `${moment().quarter()} quarter: ${ moment().startOf('quarter').format('MMMM') } – ${ moment().endOf('quarter').format('MMMM') }`,
      [Period.yearly]: `Year ${moment().format('YYYY')}`,
    }[Period[interval]];
  }

  private getQuarterly(date: Date): string {
    switch (Math.floor((date.getMonth() + 3) / 3)) {
      case 1:
        return 'I';
      case 2:
        return 'II';
      case 3:
        return 'III';
      case 4:
        return 'IV';
    }
  }

  private getWeek(date: Date): number {
    const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (+date - +firstDayOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
  }
}
